// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5b1217a8","455":"b15bad6f","977":"4942067e"}[chunkId] + ".chunk.js";
};